export const itemCollectionLinks = {
  "/AaliyahPrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/AllStarPurse": { path: "/Purses", label: "Purses Collection" },
  "/AnthonyDavis": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/Artronaut": { path: "/StickersCollection", label: "Stickers Collection" },
  "/AudreyHepburn": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/AudreyHepburnBreakfastPrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/AudreyHepburnPrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/BasquiatDetails": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/BasquiatPrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/BobMarley": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/BobMarleyDreads": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/BobMarleyJammin": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/BrittanyMurphyPrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/BruceLee": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/CancelCulture": { path: "/AbstractsCollection", label: "Abstracts Collection" },
  "/CosmoWarrior": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/CradlingBaby": { path: "/GoldCollection", label: "Gold Collection" },
  "/CreativeCosmonaut": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/CurrentEvents": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/DavidBowie": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/Deeper": { path: "/GoldCollection", label: "Gold Collection" },
  "/DivineFeminine": { path: "/AbstractsCollection", label: "Abstracts Collection" },
  "/ElizabethTaylor": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/ElizabethTaylor2": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/ElonMusk": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/Escaping": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/Familyhood": { path: "/GoldCollection", label: "Gold Collection" },
  "/FatherFamily": { path: "/GoldCollection", label: "Gold Collection" },
  "/FatherLounging": { path: "/GoldCollection", label: "Gold Collection" },
  "/FlirtyLazuliSkirt": { path: "/FlirtyLazuli", label: "Flirty Lazuli Collection" },
  "/FlirtyLazuliTop": { path: "/FlirtyLazuli", label: "Flirty Lazuli Collection" },
  "/FlirtyLazuliTwoPiece": { path: "/FlirtyLazuli", label: "Flirty Lazuli Collection" },
  "/Floating": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/FloatingInSpace": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/FloatingInSpacePrint": { path: "/QuantumPrints", label: "Quantum Entanglement Prints" },
  "/FollowYourGut": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/FoolThemNotMe": { path: "/AbstractsCollection", label: "Abstracts Collection" },
  "/ForeverEntangled": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/FreshPrince": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/Frida": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/Giannis": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/GoogleThis": { path: "/LockdownCollection", label: "Lockdown Collection" },
  "/GroundedForYou": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/GroundedForYouPrint": { path: "/QuantumPrints", label: "Quantum Entanglement Prints" },
  "/GrowingFamily": { path: "/GoldCollection", label: "Gold Collection" },
  "/HarryKane": { path: "/FutbolCollection", label: "Futbol Collection" },
  "/Iam": { path: "/StickersCollection", label: "Stickers Collection" },
  "/InfiniteFlames": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/Intentions": { path: "/AbstractsCollection", label: "Abstracts Collection" },
  "/ItCameInADream": { path: "/AbstractsCollection", label: "Abstracts Collection" },
  "/JDilla": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/JamesHarden": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/JimMorrison": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/KawhiLeonard": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/KevinDurant": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/KeyToYourHeart": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/KobePrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/KylianMbappe": { path: "/FutbolCollection", label: "Futbol Collection" },
  "/KyrieIrving": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/L": { path: "/GoldCollection", label: "Gold Collection" },
  "/LeBronCleveland": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/LeBronLA": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/LeBronLakers": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/LeapsOriginal": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/LeapsPrint": { path: "/QuantumPrints", label: "Quantum Entanglement Prints" },
  "/LeftEyeOriginal": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/LeftEyePrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/LionelMessi": { path: "/FutbolCollection", label: "Futbol Collection" },
  "/MacMiller": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/MamaBebe": { path: "/GoldCollection", label: "Gold Collection" },
  "/MarilynMonroePrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/MichaelJacksonOriginal": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/MichaelJordan": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/MichaelJordan23": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/MohamedSalah": { path: "/FutbolCollection", label: "Futbol Collection" },
  "/Mother": { path: "/GoldCollection", label: "Gold Collection" },
  "/MotherAndChild": { path: "/GoldCollection", label: "Gold Collection" },
  "/MotherCradle": { path: "/GoldCollection", label: "Gold Collection" },
  "/MotherInfant": { path: "/GoldCollection", label: "Gold Collection" },
  "/MotherPlaying": { path: "/GoldCollection", label: "Gold Collection" },
  "/Motherhood": { path: "/GoldCollection", label: "Gold Collection" },
  "/MuhammadAli": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/MyopicMen": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/Neymar": { path: "/FutbolCollection", label: "Futbol Collection" },
  "/ParadoxOriginal": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/ParadoxPrint": { path: "/QuantumPrints", label: "Quantum Entanglement Prints" },
  "/Pregnant": { path: "/GoldCollection", label: "Gold Collection" },
  "/Prince": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/PrincessDiana": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/PrincessDianaOriginal": { path: "/Prints", label: "Limited Edition Prints" },
  "/PrincessDianaPrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/PrincessLeiaOriginal": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/PrincessLeiaPrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/QueenAndPets": { path: "/GoldCollection", label: "Gold Collection" },
  "/QueenChild": { path: "/GoldCollection", label: "Gold Collection" },
  "/QueenPet": { path: "/GoldCollection", label: "Gold Collection" },
  "/QueenToddler": { path: "/GoldCollection", label: "Gold Collection" },
  "/RTronaut": { path: "/StickersCollection", label: "Stickers Collection" },
  "/ReenaRose": { path: "/RadicalCollection", label: "Radical Collection" },
  "/Reyna": { path: "/GoldCollection", label: "Gold Collection" },
  "/Risk": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/RisksOriginal": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/RisksPrint": { path: "/QuantumPrints", label: "Quantum Entanglement Prints" },
  "/RomeoAndJuliet": { path: "/LockdownCollection", label: "Lockdown Collection" },
  "/RussellWestbrook": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/SeleneBikiniTop": { path: "/SeleneCollection", label: "Selene Collection" },
  "/SeleneDress": { path: "/SeleneCollection", label: "Selene Collection" },
  "/SelenePants": { path: "/SeleneCollection", label: "Selene Collection" },
  "/SelenePrincess": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/SelenePrincessPrint": { path: "/QuantumPrints", label: "Quantum Entanglement Prints" },
  "/SelenePrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/SeleneShorts": { path: "/SeleneCollection", label: "Selene Collection" },
  "/Shaq": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/Shop": { path: "/SeleneCollection", label: "Selene Collection" },
  "/SophiaLoren": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/SpaceWars": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/StephenCurry": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/StickerBundle": { path: "/StickersCollection", label: "Stickers Collection" },
  "/Thanos": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/TheRiseOfKobeArtPrint": { path: "/Prints", label: "Limited Edition Prints" },
  "/TigerWoods": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/TraeYoung2020": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/TwinFlame": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/TwinFlameOriginal": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/TwinFlamePrint": { path: "/QuantumPrints", label: "Quantum Entanglement Prints" },
  "/UniverseOriginal": { path: "/QuantumCollection", label: "Quantum Entanglement Collection" },
  "/Vibe": { path: "/GoldCollection", label: "Gold Collection" },
  "/VicOladipo": { path: "/NBAAllStars", label: "NBA All Stars Collection" },
  "/ViewOfLa": { path: "/LockdownCollection", label: "Lockdown Collection" },
  "/VirgilAbloh": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/WWW": { path: "/AbstractsCollection", label: "Abstracts Collection" },
  "/WashingHands": { path: "/LockdownCollection", label: "Lockdown Collection" },
  "/WhitneyHoustonOriginal": { path: "/HollywoodCollection", label: "Hollywood Icons Collection" },
  "/WhitneyHoustonPrint": { path: "/HollywoodPrints", label: "Hollywood Icon Prints" },
  "/Without": { path: "/StickersCollection", label: "Stickers Collection" },
  "/YoungLove": { path: "/GoldCollection", label: "Gold Collection" },
};

export const getCollectionBackLink = (pathname, overrides = {}) => {
  if (overrides.to) {
    return {
      path: overrides.to,
      label: overrides.label || "Back to Collection",
    };
  }

  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

  return itemCollectionLinks[normalized] || null;
};

